@if (companyShopsOptions?.length) {
  <div class="shop-select-container" (appClickOutside)="opened = false">
    <div class="value-container cta-btn" (click)="toggleSelect()">
      @if (activeShop) {
        <p class="selected-value">{{ activeShop.name }}</p>
      }
      <span class="icon icon-arrow" [class.open]="opened" inlineSVG="/icons/icon-chevron-down.svg"></span>
    </div>
    <div [class.hidden]="!opened" [ngClass]="customClass" class="options-container">
      @for (option of companyShopsOptions; track option) {
        <div class="select-option" (click)="selectShop(option.value)">{{ option.key }}</div>
      }
      @if (exitOption) {
        <div class="select-option no-hover">
          <button class="btn btn-dark-theme btn-orange cta-btn" (click)="exit()">
            {{ 'global.exit' | transloco }}
          </button>
        </div>
      }
    </div>
  </div>
}
